module.exports = __webpack_public_path__ + "static/media/underline.b04b69d5.svg";